import {Controller} from "stimulus";
import Sortable from 'sortablejs'

export default class extends Controller {
    connect() {
      this.url = document.location.toString() + '/loops'
      $(this.element).load(this.url)
    }
}
